var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 32,
    viewBox: "0 0 104 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 1.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 1.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4.25,
    y: 7.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4.25,
    y: 10.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4.25,
    y: 19.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4.25,
    y: 22.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 7.25,
    y: 4.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 7.25,
    y: 7.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 7.25,
    y: 10.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 7.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 7.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 7.25,
    y: 19.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 7.25,
    y: 22.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 7.25,
    y: 25.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.25,
    y: 4.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.25,
    y: 7.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.25,
    y: 10.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.25,
    y: 19.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.25,
    y: 22.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 10.25,
    y: 25.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 1.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 4.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 7.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 10.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 19.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 22.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 25.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.25,
    y: 28.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 1.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.25,
    y: 4.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.25,
    y: 7.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.25,
    y: 10.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.25,
    y: 19.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.25,
    y: 22.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.25,
    y: 25.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 28.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 4.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 7.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 19.25,
    y: 10.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 19.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 19.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 19.25,
    y: 19.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 22.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 25.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 4.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 7.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 10.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 19.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 22.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 25.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 7.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 10.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 19.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 22.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 28.25,
    y: 13.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 28.25,
    y: 16.25,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.883 3.52734V23.069C42.883 25.0292 43.4215 25.5368 45.0445 25.5368C45.5746 25.5321 46.1039 25.4959 46.6298 25.4284V27.9699C45.9759 28.0895 45.3127 28.1501 44.6482 28.1511C41.9461 28.1511 40 27.2073 40 22.9974V3.52734H42.883Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9971 27.9329V25.2091H60.7817C60.0612 26.552 58.295 28.4752 54.8724 28.4752C51.5209 28.4752 48.71 26.6247 48.71 22.3779V9.49219H51.593V21.6522C51.593 24.0473 52.7098 25.9348 55.5929 25.9348C58.7635 25.9348 60.9982 23.6839 60.9982 20.9623V9.49219H63.8801V27.9329H60.9971Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8566 9.49268V12.2165H70.072C70.7925 10.8736 72.5587 8.94922 75.9813 8.94922C79.3328 8.94922 82.1437 10.8009 82.1437 15.0466V27.9334H79.2574V15.7734C79.2574 13.3772 78.1406 11.4908 75.2576 11.4908C72.087 11.4908 69.8523 13.7047 69.8523 16.4264V27.9334H66.98V9.49268H69.8566Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.55 18.6403C84.55 12.7241 88.0458 8.94922 93.4888 8.94922C98.8575 8.94922 101.997 12.5788 101.997 17.9873C101.997 18.5297 101.997 19.148 101.96 19.4387H87.5784C87.6506 22.7049 89.4879 25.971 93.5232 25.971C97.1268 25.971 98.4967 23.5401 98.8208 22.233H101.739C100.802 25.6814 98.208 28.4757 93.4877 28.4757C87.6861 28.4757 84.55 24.2658 84.55 18.6403ZM98.9275 16.8982C98.9275 13.849 96.766 11.4539 93.3423 11.4539C90.1717 11.4539 87.7572 13.6679 87.5773 16.8982H98.9275Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuneLogo);
export default __webpack_public_path__ + "static/media/lune-logo.68f44b4940a9c879c706ab182e2ca391.svg";
export { ForwardRef as ReactComponent };